"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shiftDesignLayers = void 0;
exports.default = shiftDesignLayersRight;
const getCoverageType_1 = require("./getCoverageType");
const constants_1 = require("../../utils/constants");
const inchRectToPercentageRect = (rectInches, containerInches) => {
  return {
    x: rectInches.x / containerInches.width,
    y: rectInches.y / containerInches.height,
    width: rectInches.width / containerInches.width,
    height: rectInches.height / containerInches.height
  };
};
/**
 * Shift a given layer rectangle left or right and return the new rectangle.
 */
const calculateShiftedPosAndDim = _ref => {
  let {
    direction,
    surface,
    rectInches
  } = _ref;
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const bleed = (_a = surface.bleed) !== null && _a !== void 0 ? _a : 0;
  const bleedArray = [].concat(bleed);
  const bleedInches = {
    bottom: (_b = bleedArray[0]) !== null && _b !== void 0 ? _b : 0,
    left: (_d = (_c = bleedArray[1]) !== null && _c !== void 0 ? _c : bleedArray[0]) !== null && _d !== void 0 ? _d : 0,
    top: (_f = (_e = bleedArray[2]) !== null && _e !== void 0 ? _e : bleedArray[0]) !== null && _f !== void 0 ? _f : 0,
    right: (_h = (_g = bleedArray[3]) !== null && _g !== void 0 ? _g : bleedArray[0]) !== null && _h !== void 0 ? _h : 0
  };
  const trimmedWidth = surface.width - bleedInches.left - bleedInches.right;
  const midp = surface.width / 2;
  const x0 = rectInches.x;
  const wt = trimmedWidth;
  const wtdiv2 = wt / 2;
  const xt0 = bleedInches.left;
  const xt1 = surface.width - bleedInches.right;
  const w0 = rectInches.width;
  /**
   * For right-to-left translations:
   *    trimmed width, divided by two
   * x1 = x0 - (wt / 2) - max(0, midp + xt0 - x0)
   * w1 = w0 - (x1 - (x0 - (wt / 2))) - max(0, x0 + w0 - xt1)
   *
   * Please see this PR description for a detailed breakdown of this formula:
   * https://github.com/ArtifactUprising/au-js-sdk/pull/623
   */
  if (direction === getCoverageType_1.SpreadSide.LEFT) {
    const x1 = x0 - wtdiv2 - Math.max(0, midp + xt0 - x0);
    const w1 = w0 - (x1 - (x0 - wtdiv2)) - Math.max(0, x0 + w0 - xt1);
    return {
      x: x1,
      width: w1,
      y: rectInches.y,
      height: rectInches.height
    };
  } else {
    /**
     * For left-to-right translations:
     * x1 = x0 - min(0, x0 - xt0) + (wt / 2)
     * w1 = w0 - (x1 - (x0 + (wt / 2))) + max(0, x0 + w0 - (midp - xt0))
     *
     * Please see this PR description for a detailed breakdown of this formula:
     * https://github.com/ArtifactUprising/au-js-sdk/pull/623
     */
    const x1 = x0 - Math.min(0, x0 - xt0) + wtdiv2;
    const w1 = w0 - (x1 - (x0 + wtdiv2)) + Math.max(0, x0 + w0 - (midp - xt0));
    return {
      x: x1,
      width: w1,
      y: rectInches.y,
      height: rectInches.height
    };
  }
};
/* Takes an array of all pre-defined Layers, along with a Design. Returns an array of the layers specified in the design,
     modified to have different IDs and x positions that have been shifted to the right by one-half of the surface. */
function shiftDesignLayersRight(templateLayers, surface) {
  return (0, exports.shiftDesignLayers)(getCoverageType_1.SpreadSide.RIGHT, templateLayers, surface);
}
const shiftDesignLayers = (direction, templateLayers, surface) => {
  return templateLayers.map(layer => {
    const oldRectangle = {
      width: layer.width * surface.width,
      height: layer.height * surface.height,
      x: layer.x * surface.width,
      y: layer.y * surface.height
    };
    const newRectangle = calculateShiftedPosAndDim({
      direction,
      surface,
      rectInches: oldRectangle
    });
    return Object.assign(Object.assign(Object.assign({}, layer), inchRectToPercentageRect(newRectangle, surface)), {
      id: direction === 'right' ? layer.id + constants_1.SHIFTED_RIGHT_APPENDIX : layer.id.replace(constants_1.SHIFTED_RIGHT_REGEX, '')
    });
  });
};
exports.shiftDesignLayers = shiftDesignLayers;